(function () {
  'use strict';
  if (window.__alpDateSheets || !window.HTMLDialogElement || typeof window.HTMLDialogElement.prototype.showModal !== 'function') return;
  window.__alpDateSheets = true;

  var instances = new Map();
  var activeSheet = null;
  var scrollStyles = null;
  var sheetId = 0;

  function lockScroll() {
    if (scrollStyles) return;
    scrollStyles = [document.documentElement, document.body].map(function (element) {
      var saved = { element: element, value: element.style.getPropertyValue('overflow'), priority: element.style.getPropertyPriority('overflow') };
      element.style.setProperty('overflow', 'hidden');
      return saved;
    });
  }

  function unlockScroll() {
    if (activeSheet || !scrollStyles) return;
    scrollStyles.forEach(function (saved) {
      if (saved.value) saved.element.style.setProperty('overflow', saved.value, saved.priority);
      else saved.element.style.removeProperty('overflow');
    });
    scrollStyles = null;
  }

  function closeSheet(record, restoreFocus) {
    if (activeSheet === record) activeSheet = null;
    record.details.open = false;
    if (record.dialog && record.dialog.open) record.dialog.close();
    unlockScroll();
    if (restoreFocus && record.summary.isConnected) record.summary.focus({ preventScroll: true });
  }

  function openSheet(record) {
    if (!record.dialog || !record.details.isConnected) return;
    if (activeSheet && activeSheet !== record) closeSheet(activeSheet, false);
    record.details.open = true;
    activeSheet = record;
    try {
      if (!record.dialog.open) record.dialog.showModal();
      lockScroll();
    } catch (_) {
      closeSheet(record, false);
      detach(record);
      record.failed = true;
      record.details.open = true;
    }
  }

  function button(label, className, record) {
    var control = document.createElement('button');
    control.type = 'button';
    control.className = className;
    control.dataset.aocSheetClose = '';
    control.textContent = label;
    control.addEventListener('click', function () { closeSheet(record, true); });
    return control;
  }

  function attach(record, root) {
    if (record.dialog || record.failed) return;
    record.details.open = false;
    var dialog = document.createElement('dialog');
    dialog.className = 'aoc-date-sheet';
    var title = document.createElement('h2');
    title.className = 'aoc-date-sheet__title';
    title.id = 'aoc-date-sheet-title-' + (++sheetId);
    var key = record.details.dataset.aocGroupPanel;
    var labels = { perf: 'sheetPerfLabel', gen: 'sheetGenLabel', casa: 'sheetCasaLabel' };
    title.textContent = root.dataset[labels[key] || 'sheetMoreLabel'] || record.summary.textContent.replace(/[+\u2212]/g, '').replace(/\s*\d+\s*$/, '').trim();
    dialog.setAttribute('aria-labelledby', title.id);
    var header = document.createElement('div');
    header.className = 'aoc-date-sheet__header';
    header.appendChild(title);
    var close = button('×', 'aoc-date-sheet__close', record);
    close.setAttribute('aria-label', root.dataset.sheetCloseLabel || 'Cerrar');
    header.appendChild(close);
    record.placeholder = document.createComment('Date filter panel');
    record.details.insertBefore(record.placeholder, record.body);
    record.body.classList.add('aoc-date-sheet__body');
    dialog.appendChild(header);
    dialog.appendChild(record.body);
    if (key) {
      var footer = document.createElement('div');
      footer.className = 'aoc-date-sheet__footer';
      footer.appendChild(button(root.dataset.sheetDoneLabel || 'Ver perfumes', 'aoc-button', record));
      dialog.appendChild(footer);
    }
    record.details.appendChild(dialog);
    record.dialog = dialog;
    dialog.addEventListener('cancel', function (event) {
      event.preventDefault();
      closeSheet(record, true);
    });
    dialog.addEventListener('close', function () {
      if (record.dialog !== dialog || dialog.open) return;
      closeSheet(record, false);
    });
    dialog.addEventListener('click', function (event) {
      if (event.target !== dialog) return;
      var bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) closeSheet(record, true);
    });
  }

  function detach(record) {
    if (!record.dialog) return;
    var dialog = record.dialog;
    var hadFocus = dialog.contains(document.activeElement);
    closeSheet(record, false);
    record.placeholder.replaceWith(record.body);
    record.body.classList.remove('aoc-date-sheet__body');
    record.dialog = null;
    record.placeholder = null;
    dialog.remove();
    if (hadFocus && record.summary.isConnected) record.summary.focus({ preventScroll: true });
  }

  function init(root) {
    if (instances.has(root)) return;
    var media = window.matchMedia('(max-width: 749px)');
    var records = Array.from(root.querySelectorAll('.aoc-group, .aoc-filters')).map(function (details) {
      return { details: details, summary: details.querySelector('summary'), body: details.querySelector('.aoc-group-panel, .aoc-filters__body'), dialog: null, placeholder: null };
    }).filter(function (record) { return record.summary && record.body; });
    if (!records.length) return;

    records.forEach(function (record) {
      record.onClick = function (event) {
        if (!media.matches || !record.dialog) return;
        event.preventDefault();
        if (record.dialog.open) closeSheet(record, true);
        else openSheet(record);
      };
      record.onToggle = function () {
        if (record.details.open) records.forEach(function (other) {
          if (other !== record && other.details.open) closeSheet(other, false);
        });
        if (!media.matches || !record.dialog) return;
        if (record.details.open && !record.dialog.open) openSheet(record);
        else if (!record.details.open && record.dialog.open) closeSheet(record, record.dialog.contains(document.activeElement));
      };
      record.summary.addEventListener('click', record.onClick);
      record.details.addEventListener('toggle', record.onToggle);
    });

    function closeOutside(event) {
      if (media.matches || records.some(function (record) { return record.details.contains(event.target); })) return;
      records.forEach(function (record) { if (record.details.open) closeSheet(record, false); });
    }
    function closeWithEscape(event) {
      if (media.matches || event.key !== 'Escape') return;
      records.forEach(function (record) {
        if (record.details.open) closeSheet(record, record.details.contains(document.activeElement));
      });
    }
    document.addEventListener('click', closeOutside);
    document.addEventListener('keydown', closeWithEscape);

    function updateMode() {
      if (media.matches) {
        records.forEach(function (record) { attach(record, root); });
        root.classList.add('aoc-date-sheets-ready');
      } else {
        records.forEach(detach);
        root.classList.remove('aoc-date-sheets-ready');
      }
    }
    media.addEventListener('change', updateMode);
    instances.set(root, function () {
      media.removeEventListener('change', updateMode);
      document.removeEventListener('click', closeOutside);
      document.removeEventListener('keydown', closeWithEscape);
      records.forEach(function (record) {
        detach(record);
        record.summary.removeEventListener('click', record.onClick);
        record.details.removeEventListener('toggle', record.onToggle);
      });
      root.classList.remove('aoc-date-sheets-ready');
      instances.delete(root);
    });
    updateMode();
  }

  function enhance(scope) {
    if (scope.matches && scope.matches('[data-aoc-date]')) init(scope);
    scope.querySelectorAll('[data-aoc-date]').forEach(init);
  }
  document.addEventListener('shopify:section:load', function (event) { enhance(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    instances.forEach(function (dispose, root) { if (event.target.contains(root)) dispose(); });
  });
  enhance(document);
})();
